import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "otp-mobile-number-verification"
    }}>{`OTP (Mobile Number Verification)`}</h1>
    <p>{`We implement the `}<inlineCode parentName="p">{`OTP`}</inlineCode>{` feature on ChawkBazar `}<inlineCode parentName="p">{`v2.2.0`}</inlineCode>{`. So if you want to use `}<inlineCode parentName="p">{`OTP`}</inlineCode>{` with `}<inlineCode parentName="p">{`ChawkBazar,`}</inlineCode>{` then make sure your ChawkBazar is `}<inlineCode parentName="p">{`v2.2.0`}</inlineCode>{` or later.`}</p>
    <p>{`With the OTP feature, you can do,`}</p>
    <pre><code parentName="pre" {...{}}>{`- Login with Mobile Number
- OTP verification for updating Mobile Number in profile update section
- OTP verification during checkout process in customer contact section
`}</code></pre>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <p>{`As of today, we implement two service providers for OTP. One is `}<inlineCode parentName="p">{`Twilio,`}</inlineCode>{` and another is `}<inlineCode parentName="p">{`MessageBird.`}</inlineCode></p>
    <h3 {...{
      "id": "twilio-configuration"
    }}>{`Twilio Configuration:`}</h3>
    <p>{`If you want to use `}<inlineCode parentName="p">{`Twilio`}</inlineCode>{` as your OTP service provider, then follow this procedure,`}</p>
    <ol>
      <li parentName="ol">{`Create an account at `}<a parentName="li" {...{
          "href": "https://www.twilio.com/"
        }}>{`Twilio`}</a></li>
      <li parentName="ol">{`After that, go to the `}<inlineCode parentName="li">{`Twilio Console Panel`}</inlineCode>{` and copy the `}<inlineCode parentName="li">{`ACCOUNT SID,`}</inlineCode>{` and `}<inlineCode parentName="li">{`AUTH TOKEN`}</inlineCode>{` key and add this key to your `}<inlineCode parentName="li">{`api/.env`}</inlineCode>{` file`}</li>
    </ol>
    <p><img alt="TwilioConfig1.png" src={require("./images/TwilioConfig1.png")} /></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`After that, go to the `}<inlineCode parentName="p">{`Verify`}</inlineCode>{` option from the `}<inlineCode parentName="p">{`Sidebar`}</inlineCode>{` panel,
`}<img alt="GoToVerify.png" src={require("./images/GoToVerify.png")} /></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`And from `}<inlineCode parentName="p">{`verify dashboard,`}</inlineCode>{` create a service.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add add that service key to `}<inlineCode parentName="p">{`api/.env -> TWILIO_VERIFICATION_SID`}</inlineCode></p>
      </li>
    </ol>
    <p><img alt="Verify.png" src={require("./images/Verify.png")} /></p>
    <p><img alt="AddNewVerify.png" src={require("./images/AddNewVerify.png")} /></p>
    <h4 {...{
      "id": "verify-geo-permissions"
    }}>{`Verify Geo Permissions`}</h4>
    <p>{`To enable an SMS system in your country, go to this link,`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.twilio.com/docs/verify/preventing-toll-fraud/verify-geo-permissions"
      }}>{`https://www.twilio.com/docs/verify/preventing-toll-fraud/verify-geo-permissions`}</a></p>
    <p>{`and enable your country's `}<inlineCode parentName="p">{`SMS Channel`}</inlineCode>{` and `}<inlineCode parentName="p">{`Voice Channel.`}</inlineCode></p>
    <p><img alt="OtpGeoSms" src={require("./images/OtpGeoSms.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Without this verification, no SMS will be delivered.`}</p>
    </blockquote>
    <p>{`With that, your configuration is complete.`}</p>
    <h3 {...{
      "id": "messagebird"
    }}>{`MessageBird:`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Use only one service provider for OTP service, so use this `}<inlineCode parentName="p">{`MessageBird`}</inlineCode>{` configuration only if you want to use `}<inlineCode parentName="p">{`MessageBird`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`Twilio.`}</inlineCode></p>
    </blockquote>
    <p>{`To configure `}<inlineCode parentName="p">{`MessageBird,`}</inlineCode>{` follow this procedure,`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create an account from `}<a parentName="p" {...{
            "href": "https://www.messagebird.com/en/"
          }}>{`MessageBird`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After creating the account, go to the `}<inlineCode parentName="p">{`API Getting Started`}</inlineCode>{` and follow all the procedures step by step.
`}<img alt="MessageBirdProcedure.png" src={require("./images/MessageBirdProcedure.png")} /></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After completing the profile, copy the `}<inlineCode parentName="p">{`API`}</inlineCode>{` key from `}<inlineCode parentName="p">{`MessageBird`}</inlineCode>{` and paste it to `}<inlineCode parentName="p">{`API/.env`}</inlineCode></p>
      </li>
    </ol>
    <p><img alt="CopyMessageBirtAPI.png" src={require("./images/CopyMessageBirtAPI.png")} /></p>
    <p><img alt="MessageBirdAPIKey.png" src={require("./images/MessageBirdAPIKey.png")} /></p>
    <p>{`With that, `}<inlineCode parentName="p">{`MessageBird`}</inlineCode>{` is appropriately configured for the OTP Service.`}</p>
    <h2 {...{
      "id": "frontend-demo"
    }}>{`FrontEnd Demo`}</h2>
    <h3 {...{
      "id": "login-with-mobile-number"
    }}>{`Login with Mobile Number:`}</h3>
    <p>{`After configuration, you will be able to use `}<inlineCode parentName="p">{`mobile number`}</inlineCode>{` as a login provider. When users select the `}<inlineCode parentName="p">{`Join`}</inlineCode>{` button, they'll get an option `}<inlineCode parentName="p">{`Login with mobile`}</inlineCode>{` to use a mobile number as a login provider.`}</p>
    <p><img alt="MobileLogin.png" src={require("./images/MobileLogin.png")} /></p>
    <p><img alt="LoginMobileVerify.png" src={require("./images/LoginMobileVerify.png")} /></p>
    <h3 {...{
      "id": "otp-verification-during-checkout-process"
    }}>{`OTP Verification During Checkout Process:`}</h3>
    <p>{`Similarly, when users go to the checkout page, they'll get a form to verify their mobile number.`}</p>
    <p>{`For the front end, you don't have to do anything. When a user goes to the `}<inlineCode parentName="p">{`checkout`}</inlineCode>{` page, they get a phone number box to add their number and verify it.`}</p>
    <p><img alt="OTPFrontend.png" src={require("./images/OTPFrontend.png")} /></p>
    <h3 {...{
      "id": "otp-verification-for-updating-mobile-number"
    }}>{`OTP Verification For Updating Mobile Number:`}</h3>
    <p>{`Users also can change the number from their profile.`}</p>
    <p><img alt="ChangeNumber.png" src={require("./images/ChangeNumber.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      